

import { FETCH_BUSINESS_UNIT_ACC_DETAILS_FAILURE, FETCH_BUSINESS_UNIT_ACC_DETAILS_REQUEST, FETCH_BUSINESS_UNIT_ACC_DETAILS_RESET, FETCH_BUSINESS_UNIT_ACC_DETAILS_SUCCESS } from "../actions/businessUnitAccountDetailsActions";

  
  const initialState = {
    acc_bu_details: {},
    acc_bu_details_loading: true,
    acc_bu_details_error: null,
  };
  
  const businessUnitAccDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_BUSINESS_UNIT_ACC_DETAILS_REQUEST:
        return { ...state, acc_bu_details_loading: true , payload: action.payload};
      case FETCH_BUSINESS_UNIT_ACC_DETAILS_SUCCESS:
        return { ...state, acc_bu_details_loading: false, acc_bu_details: action.payload };
      case FETCH_BUSINESS_UNIT_ACC_DETAILS_FAILURE:
        return { ...state, acc_bu_details_loading: false, acc_bu_details_error: action.payload };
      case FETCH_BUSINESS_UNIT_ACC_DETAILS_RESET:
        return { ...state, acc_bu_details_loading: false, acc_bu_details: {}}  
      default:
        return state;
    }
  };
  
  export default businessUnitAccDetailsReducer;
  